import { render, staticRenderFns } from "./BottomCompo.vue?vue&type=template&id=39475be0&"
import script from "./BottomCompo.vue?vue&type=script&lang=js&"
export * from "./BottomCompo.vue?vue&type=script&lang=js&"
import style0 from "./BottomCompo.vue?vue&type=style&index=0&id=39475be0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports